export const SITE = {
  name: "Mister Pollo",
  since: "1998",
  city: "Volla (NA)",
  address: "Via San Giorgio 76, Centro Carpe Diem, Volla (NA)",
  phoneDisplay: "081 18330419",
  phoneHref: "tel:+3908118330419",
  mobileDisplay: "335 282535",
  mobileHref: "tel:+39335282535",
  whatsappDisplay: "335 282535",
  whatsappHref: `https://wa.me/39335282535?text=${encodeURIComponent("Ciao Mister Pollo! Vorrei prenotare:")}`,
  hours: ["Aperti dal lunedì al sabato"],
  mapSrc: `https://maps.google.com/maps?q=${encodeURIComponent("Via San Giorgio 76, Volla NA")}&z=16&output=embed`,
};

export const CATEGORIES = ["Girarrosto", "Contorni", "Fritti"];
